module.exports = __webpack_public_path__ + "static/img/repertory.dbe61396.png";